import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5718a354"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "calendar-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VDatePicker = _resolveComponent("VDatePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.calendarType === 'start')
      ? (_openBlock(), _createBlock(_component_VDatePicker, {
          key: 0,
          color: "dot-color",
          locale: _ctx.configuration!.locale,
          "is-expanded": "",
          "is-inline": "",
          transparent: "",
          "min-date": new Date(),
          borderless: "",
          modelValue: _ctx.date,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.date) = $event)),
          mode: "date"
        }, null, 8, ["locale", "min-date", "modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.calendarType === 'end')
      ? (_openBlock(), _createBlock(_component_VDatePicker, {
          key: 1,
          color: "dot-color",
          locale: _ctx.configuration!.locale,
          "is-expanded": "",
          "is-inline": "",
          transparent: "",
          "min-date": _ctx.configuration && _ctx.configuration.minDateForEnd ? _ctx.configuration.minDateForEnd : new Date(),
          borderless: "",
          modelValue: _ctx.date,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.date) = $event)),
          mode: "date"
        }, null, 8, ["locale", "min-date", "modelValue"]))
      : _createCommentVNode("", true)
  ]))
}